import mutate from '@wittignl/js-core/apollo/mutations/mutate'

import CreateProjectMutation from 'gql/mutations/project/CreateProject.gql'
import UpdateProjectMutation from 'gql/mutations/project/UpdateProject.gql'
import DeleteProjectMutation from 'gql/mutations/project/DeleteProject.gql'

export default class {

    static create(input, userIds){

        return mutate(CreateProjectMutation, { input, userIds });
    }

    static update(input, addedUserIds, removedUserIds){

        return mutate(UpdateProjectMutation, { input, addedUserIds, removedUserIds });
    }

    static delete(id){

        return mutate(DeleteProjectMutation, { id });
    }
}
